import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { articleService, IArticle } from '../../services/articleService';
import StoryCard from '../../components/editorial/StoryCard';

const ArticlesPage: React.FC = () => {
  const { category } = useParams();
  const [articles, setArticles] = useState<IArticle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(false);
    (category ? articleService.getByCategory(category) : articleService.getAll())
      .then(data => { if (active) setArticles(data); })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [category, retry]);
  return <div className="journal-page archive-page">
    <h1 className="sr-only">{category || 'All stories'}</h1>
    {loading ? <div className="editorial-empty" role="status">Loading stories…</div> : error ? <div className="editorial-empty"><p>Unable to load stories.</p><button className="editorial-button" onClick={() => setRetry(value => value + 1)}>Try again ↗</button></div> : articles.length ? <div className="story-grid">{articles.map((article, index) => <StoryCard key={article.id} article={article} index={index} />)}</div> : <div className="editorial-empty">New stories in {category || 'the magazine'} are coming soon.</div>}
  </div>;
};
export default ArticlesPage;
